export * from './AssetApi';
import { AssetApi } from './AssetApi';
export * from './AuctionApi';
import { AuctionApi } from './AuctionApi';
export * from './AuctionAssetApi';
import { AuctionAssetApi } from './AuctionAssetApi';
export * from './TransactionApi';
import { TransactionApi } from './TransactionApi';
export * from './ConfigApi';
import { ConfigApi } from './ConfigApi';
export * from './ContentModuleApi';
import { ContentModuleApi } from './ContentModuleApi';
export * from './FaveApi';
import { FaveApi } from './FaveApi';
export * from './FoundationApi';
import { FoundationApi } from './FoundationApi';
import { TeamApi } from './TeamApi';
export * from './TeamApi';
export * from './VenueApi';
import { VenueApi } from './VenueApi';
import { FoundationEmailApi } from './FoundationEmailApi';
export * from './FoundationEmailApi';
import { MessagingApi } from './MessagingApi';
export * from './MessagingApi';
import { ContentApi } from './ContentApi';
export * from './ContentApi';
import { RepeatOffenderApi } from './RepeatOffenderApi';
export * from './RepeatOffenderApi';
import { UserApi } from './UserApi';
export * from './UserApi';
import { AdminUserApi } from './AdminUserApi';
export * from './AdminUserApi';
import { AgreementApi } from './AgreementApi';
export * from './AgreementApi';
import { AnnouncementApi } from './AnnouncementApi';
export * from './AnnouncementApi';
import { TeamRequestApi } from './TeamRequestApi';
export * from './TeamRequestApi';
import { AccountingReportApi } from './AccountingReportApi';
export * from './AccountingReportApi';
import { AdminBlockDomainsApi } from './AdminBlockDomainsApi';
export * from './AdminBlockDomainsApi';
export * from './LandingPageApi';
import { LandingPageApi } from './LandingPageApi';
import { AdminAnalyticsApi } from './AdminAnalyticsApi';
export * from './AdminAnalyticsApi';
import { CampaignApi } from './CampaignApi';
export * from './CampaignApi';


export const API_SERVICES = [
  AgreementApi,
  CampaignApi,
  AssetApi,
  AuctionApi,
  AuctionAssetApi,
  AdminUserApi,
  TransactionApi,
  ConfigApi,
  ContentModuleApi,
  FaveApi,
  FoundationApi,
  FoundationEmailApi,
  MessagingApi,
  TeamApi,
  UserApi,
  VenueApi,
  ContentApi,
  RepeatOffenderApi,
  AnnouncementApi,
  TeamRequestApi,
  AccountingReportApi,
  AdminBlockDomainsApi,
  LandingPageApi,
  AdminAnalyticsApi
];
